import { render, staticRenderFns } from "./editRemittance.vue?vue&type=template&id=41dc7032&scoped=true&"
import script from "./editRemittance.vue?vue&type=script&lang=js&"
export * from "./editRemittance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc7032",
  null
  
)

export default component.exports